import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import AppTableHead from "./AppTableHead";
import AppColor from "utilities/AppColor";

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
    width: "100%",
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: AppColor.mainColor
    },
    '& .MuiTableCell-head': {
      fontWeight: `${700}!important`
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      minWidth: 650
    },
  },
}));

const AppTable = (props) => {
  const classes = useStyles2();
  const {
      onRequestSort,
      order,
      orderBy,
      rowCount,
      rowCountIsCheck,
      headCells,
      numSelected,
      onSelectAllClick,
      checkboxIndeterminate,
      checkboxChecked,
      isOnSelectedAll,
      classesContainer = ''
  } = props;
  return (
    <TableContainer component={Paper} className={classesContainer}>
      <Table className={classes.table} aria-label="pagination table">
          <AppTableHead
              onRequestSort={onRequestSort}
              order={order}
              orderBy={orderBy}
              rowCountIsCheck={rowCountIsCheck === undefined ? rowCount : rowCountIsCheck}
              headCells={headCells}
              numSelected={numSelected}
              onSelectAllClick={onSelectAllClick}
              checkboxIndeterminate={checkboxIndeterminate}
              checkboxChecked={checkboxChecked}
              isOnSelectedAll={isOnSelectedAll}
          />
        {props.children}
      </Table>
    </TableContainer>
  );
};

AppTable.propTypes = {
    children: PropTypes.any,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    rowCountIsCheck: PropTypes.number,
    headCells: PropTypes.array.isRequired,
    checkboxIndeterminate: PropTypes.bool,
    checkboxChecked: PropTypes.bool,
    isOnSelectedAll: PropTypes.bool
};

export default AppTable;